import { UserLoginForm } from '../../../components/forms/user_login'
import login_banner from '../../../assets/video/output-onlinegiftools.gif'
import Aos from 'aos'
import 'aos/dist/aos.css'

export const LoginImport = {
    login_banner,
    UserLoginForm,
    Aos,
}